import { render } from "./CogsDataContent.vue?vue&type=template&id=e604271c&scoped=true"
import script from "./CogsDataContent.vue?vue&type=script&lang=js"
export * from "./CogsDataContent.vue?vue&type=script&lang=js"

import "./CogsDataContent.vue?vue&type=style&index=0&id=e604271c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e604271c"]])

export default __exports__